import React, { useState } from 'react';
import Modal from '../../components/Modal';

/**
 * A modal to confirm transfer and allow the user to select which requisitions to transfer
 */
const PITLTransferModal = ({ gearOrder, closeModal, onSubmit }) => {
	// Can transfer any pack that has not been accessioned
	const transferablePacks = gearOrder.requisitions.filter((gearReq) => !gearReq.accessionNo);
	// Default selection if only one pack is available
	let defaultSelection = transferablePacks.length === 1 ? [transferablePacks[0].id] : [];

	const [selectedPacks, setSelectedPacks] = useState(defaultSelection);

	const handleReqSelection = (event) => {
		const target = event.currentTarget;
		const reqId = Number(target.value);
		if (target.checked) {
			// Add to selected packs
			setSelectedPacks((prevSelected) => [...prevSelected, reqId]);
		} else {
			// Remove from selected packs
			setSelectedPacks((prevSelected) => prevSelected.filter((id) => id !== reqId));
		}
	};

	const handleSubmit = () => {
		onSubmit(selectedPacks);
	};

	return (
		<Modal
			title="Transfer Collection Packs"
			confirmAction="Transfer My Order"
			cancelAction="Cancel"
			disableConfirm={!selectedPacks.length} // Disable confirm button if no packs are selected
			onSave={handleSubmit}
			onCancel={closeModal}
			modalHidden={closeModal}
			// The modal is nested inside a 'small' class. Bump the font-size back up to normal
			displayProps={{ modalContent: { style: { fontSize: '15px' } } }}
		>
			<div>
				<span>
					Collection packs may be transferred for <strong>an additional $15 physician fee</strong>. This fee
					covers the cost of authorizing the testing for the new individual.
				</span>
				{transferablePacks.length > 1 && (
					<div className="mt-10">
						<p className="mb-10">Please select the packs you want to transfer:</p>
						<div className="ml-10">
							{transferablePacks.map((req) => {
								return (
									<div key={req.id} className="form-group">
										<div className="checkbox">
											<label>
												<input type="checkbox" value={req.id} onChange={handleReqSelection} />
												{req.omsOrderableItemName}
											</label>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				)}
			</div>
		</Modal>
	);
};

export default PITLTransferModal;
